export default {
  FETCH: 'fundraising/FETCH',
  FETCH_SUCCESS: 'fundraising/FETCH_SUCCESS',
  FETCH_FAILED: 'fundraising/FETCH_FAILED',
  SAVE_DESIGN: 'fundraising/SAVE_DESIGN',
  SAVE_SUCCESS: 'fundraising/SAVE_SUCCESS',
  SAVE_FAILED: 'fundraising/SAVE_FAILED',
  SET_SKIP_OVERVIEW: 'fundraising/SET_SKIP_OVERVIEW',
  UPDATE_ESTIMATED_PROFIT: 'fundraising/UPDATE_ESTIMATED_PROFIT',
  UPDATE_GOAL_QUANTITY: 'fundraising/UPDATE_GOAL_QUANTITY',
  UPDATE_PRINT_MINIMUM: 'fundraising/UPDATE_PRINT_MINIMUM',
  UPDATE_PROFIT: 'fundraising/UPDATE_PROFIT',
  UPDATE_SALE_PRICE: 'fundraising/UPDATE_SALE_PRICE'
};
